import { render, staticRenderFns } from "./totalVote.vue?vue&type=template&id=290a482a&scoped=true"
import script from "./totalVote.vue?vue&type=script&lang=js"
export * from "./totalVote.vue?vue&type=script&lang=js"
import style0 from "./totalVote.vue?vue&type=style&index=0&id=290a482a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290a482a",
  null
  
)

export default component.exports